module.exports = __webpack_public_path__ + "static/media/youtubescan.034cc18c.png";